import { useConfigStore as t } from "@phx-husky/auth-context";
var o = function o() {
  var _t = t(),
    o = _t.config,
    e = o.translations,
    n = o.fieldsSetup,
    r = o.renderLogo;
  return {
    translations: e,
    fieldsSetup: n,
    renderLogo: r
  };
};
export { o as useConfig };